export const LANGUAGES_MAP = new Map([
  ['fr', 'Français'],
  ['en', 'English'],
  ['nl', 'Nederlands'],
  ['es', 'Español'],
  ['de', 'Deutsch'],
]);
